//action
import {
    RESET_FORGOT_PASSWORD,
    RESET_FORGOT_PASSWORD_FAIL,
    RESET_FORGOT_PASSWORD_SUCCESS,
    RESET_FORGOT_PASSWORD_RESET
} from "../action/resetForgotPasswordAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {

        case RESET_FORGOT_PASSWORD:
            return {
                ...state,
                apiState: "loading"
            }
        case RESET_FORGOT_PASSWORD_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case RESET_FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response,
                message: action.response && action.response.data && action.response.data.message || api_err_msg
            }
        case RESET_FORGOT_PASSWORD_RESET:
            return initialState
        default:
            return state
    }
}